import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@wehunt/core-web'
import { useApiFetch } from '../../shared/api'

export interface HuntStatsDto {
  pendingInvitations: number
  upcomingHunts: number
  endedHunts: number
  harvestToDate: number
}

export function useHuntStats() {
  const call = useApiFetch()
  const { state } = useAuth()
  const uid = state.status === 'signed-in' ? state.user.uid : undefined
  return useQuery({
    queryKey: ['clubhouse', 'me', 'hunts', 'stats', uid],
    queryFn: () => call<HuntStatsDto>('/clubhouse/me/hunts/stats'),
    enabled: !!uid,
    staleTime: 60 * 1000,
  })
}
